
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connection-point.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-registry-connection-point-demo-connection-point"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connection-point.zh.md?type=demo')
};